import { motion } from 'framer-motion'
import { useState } from 'react'

const cardVariants = {
  firstInitialState: {
    rotateY: 0,
  },
  firstStep: {
    rotateY: 90,
    transition: {
      duration: 0.25,
      ease: 'easeInOut',
    },
  },
  secondInitialState: {
    rotateY: 90,
  },
  secondStep: {
    rotateY: 0,
    transition: {
      duration: 0.25,
      ease: 'easeInOut',
    },
  },
}

interface TransparentCardDesktopSelectedProps {
  title: string
  body: string
}

export const TransparentCardDesktopSelected = ({
  title,
  body,
}: TransparentCardDesktopSelectedProps) => {
  const [startSecond, setStartSecond] = useState(false)

  return (
    <>
      {startSecond ? (
        <motion.div
          className='flex min-h-[350px] 3xl:h-[400px] p-5 flex-col items-start gap-4 self-stretch text-white rounded-xl border border-[#818285] bg-[rgba(0,0,0,0.50)] shadow-[0px_8px_8px_0px_rgba(0,0,0,0.50)]'
          variants={cardVariants}
          initial='secondInitialState'
          animate='secondStep'
          style={{
            transformStyle: 'preserve-3d',
          }}
        >
          <h3 className='text-lg font-medium lg:text-2xl 3xl:text-2xl'>{title}</h3>
          <p
            className='text-xs text-normal text-[#D1D3D7] leading-4 tracking-[0.4px] lg:text-sm 3xl:text-lg 3xl:leading-6'
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </motion.div>
      ) : (
        <motion.div
          className='flex min-h-[350px] 3xl:h-[400px] p-5 flex-col justify-center items-center gap-4 self-stretch text-white rounded-xl border border-[#818285] bg-[linear-gradient(180deg,_rgba(255,255,255,0.3)_0%,_rgba(0,0,0,0.30)_20%)] shadow-[0px_8px_8px_0px_rgba(0,0,0,0.50)]'
          variants={cardVariants}
          animate='firstStep'
          onAnimationComplete={() => setStartSecond(true)}
          style={{
            transformStyle: 'preserve-3d',
          }}
        >
          <h3 className='text-lg font-medium lg:text-2xl 3xl:text-2xl'>{title}</h3>
        </motion.div>
      )}
    </>
  )
}
